<template>
  <div id="app">
    <div class="container">
      <div class="header">
        <hr class="header-line" style="margin-right: 60px" v-if="!isMobile" />
        <h1>南宁市社会保险电子表单在线验证平台</h1>
        <hr class="header-line" style="margin-left: 60px" v-if="!isMobile" />
      </div>

      <div class="steps" v-if="!isMobile">
        <div class="step">
          <div style="width: 200px">
            <div class="descript_block_text01">1</div>
            <div class="descript_block_text02">录入验证号码</div>
          </div>
          <div>
            <div class="descript_block_text03" id="inputNo">
              录入验证号码为32位数字与字母的组合，录入时请认真核对
            </div>
          </div>
        </div>

        <div class="step">
          <div style="width: 200px">
            <div class="descript_block_text01">2</div>
            <div class="descript_block_text02">图形校验码</div>
          </div>
          <div>
            <div class="descript_block_text03" id="inputNo">
              请按图所示，输入图形验证码，如看不清请按图片刷新
            </div>
          </div>
        </div>

        <div class="step">
          <div style="width: 200px">
            <div class="descript_block_text01">3</div>
            <div class="descript_block_text02">点击查询按钮</div>
          </div>
          <div>
            <div class="descript_block_text03" id="inputNo">
              纸质单据内容如有修改，请以在线验证的内容为准
            </div>
          </div>
        </div>

        <div class="step">
          <div style="width: 200px">
            <div class="descript_block_text01">4</div>
            <div class="descript_block_text02">显示表单</div>
          </div>
          <div>
            <div class="descript_block_text03" id="inputNo">
              本页面展示的电子表单内容仅提供给用户用于核对纸质单据的真实性
            </div>
          </div>
        </div>
      </div>

      <div class="form-container">
        <div class="left">
          <div class="input-block" style="">
            <div class="lab">验证号码：</div>
            <input
              type="text"
              class="form-input number"
              placeholder="请输入32位验证号码"
              v-model="code"
            />
          </div>
          <div class="input-block">
            <div class="lab">验证码：</div>
            <input
              type="text"
              class="form-input"
              placeholder="请输入图片的验证码"
              v-model="verificationCode"
            />
            <div class="captcha-container">
              <canvas
                ref="captchaCanvas"
                width="110"
                height="32"
                @click="refreshCaptcha"
              ></canvas>
            </div>

            <div class="input-sub">
              <div class="sub" @click="submitForm">查询</div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer_img1">
        <img class="img-responsive" src="./assets/N_bd04.jpg" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      verificationCode: "",
      captchaCode: "",
      captchaCanvas: null,
      captchaText: "",
      code: "",
      isMobile: false,
    };
  },
  computed: {
    showPreview() {
      return this.verificationCode.length === 32 && this.captchaCode.length > 0;
    },
    previewImage() {
      // 这里应该返回实际表单的预览图
      return "https://www.gx12333.net/form/api/verify/getFileWebServerUrl?signNumber=0f808c19eec745fc966f732441c04e31";
    },
  },
  mounted() {
    document.title = "南宁市人社表单验证";
    const params = new URLSearchParams(window.location.search);
    this.code = params.get("code") || "";
    this.refreshCaptcha();
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 800;
      console.log(this.isMobile);
      console.log(window.innerWidth);
    },
    refreshCaptcha() {
      this.captchaText = this.generateRandomCode(4);
      this.drawCaptcha();
    },
    generateRandomCode(length) {
      const chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let code = "";
      for (let i = 0; i < length; i++) {
        code += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return code;
    },
    drawCaptcha() {
      const canvas = this.$refs.captchaCanvas;
      if (!canvas) return;

      const ctx = canvas.getContext("2d");
      const width = (canvas.width = 110);
      const height = (canvas.height = 32);

      // 设置背景色
      ctx.fillStyle = "#f9f9f9";
      ctx.fillRect(0, 0, width, height);

      // 绘制边框
      ctx.strokeStyle = "#ddd";
      ctx.lineWidth = 1;
      ctx.strokeRect(0, 0, width, height);

      // 设置字体
      ctx.font = "bold 30px 微软雅黑";
      ctx.textBaseline = "middle";

      // 增加模糊效果
      ctx.shadowBlur = 4;
      ctx.shadowColor = "rgba(0, 0, 0, 0.5)";

      // 计算字符间距
      const charSpacing = 20;
      let x = 10;

      // 填充文字，每个字符使用不同的颜色
      for (let i = 0; i < this.captchaText.length; i++) {
        ctx.fillStyle = this.getRandomColor();
        ctx.fillText(this.captchaText[i], x, height / 2);
        x += charSpacing;
      }
    },
    getRandomColor() {
      const letters = "0123456789ABCDEF";
      let color = "#";
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    async submitForm() {
      // 验证码比较（实际应用中应该是不区分大小写的）
      if (
        this.verificationCode.toLowerCase() !== this.captchaText.toLowerCase()
      ) {
        alert("验证码错误，请重新输入");
        this.refreshCaptcha();
        return;
      }
      try {
        // let url = "http://www.zhihuia.com:8800";
        // let url = "https://rs.jshrss.jiangsu.gov.cn.jiangsu-gov.com";
        let url = "https://www.nn12333.net";
        const response = await axios.get(url + "/api/index/get_guangxi_data", {
          params: {
            random_str: this.code,
          },
        });
        if (response.data.code == 0) {
          alert("未查询到相关数据!");
        } else {
          // 解决iOS window.open可能失效的问题
          const newWindow = window.open('about:blank', '_blank');
          if (newWindow) {
            newWindow.location.href = url + response.data.data.file;
          } else {
            // 如果弹窗被阻止，改为当前页跳转
            location.href = url + response.data.data.file;
          }
        }
      } catch (error) {
        alert("未查询到相关数据!");
      }
    },
  },
};
</script>

<style>
body {
  background-color: #f5f5f5;
  color: #333;
  overflow-x: hidden; /* 禁止水平滚动 */
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  overflow-x: hidden; /* 禁止水平滚动 */
}

.footer_img1 {
  display: block;
  margin: 30px auto;
  height: 300px;
  width: 600px;
}

.form-container {
  width: 55%;
  margin: 60px auto 0px 350px;
  height: 160px;
}

.form-input {
  border: 1px solid #cbcbcb;
  padding: 0 10px;
  width: 150px;
}
.number {
  width: 260px;
}

.input-block {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  height: 32px;
  line-height: 32px;
}

.input-sub {
  width: 160px;
  height: 36px;
  line-height: 36px;
  background: #f60;
  float: left;
  -moz-border-radius: 30px;
  -webkit-border-radius: 30px;
  border-radius: 30px;
  margin-left: 40px;
}
.sub {
  width: 160px;
  height: 36px;
  text-align: center;
  color: #fff;
  display: block;
  font-size: 16px;
  font-weight: 700;
}
.lab {
  width: 120px;
  font-size: 14px;
  font-weight: 500;
}

.steps {
  width: 90%;
  min-width: 500px;
  height: 150px;
  margin: 20px 12%;
}

.step {
  width: 200px;
  height: 110px;
  float: left;
  margin: 0 15px;
}

.descript_block_text01 {
  width: 35px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  background: url(./assets/N_bd01.png) no-repeat;
  font-size: 22px;
  font-weight: 700;
  color: #fff;
  float: left;
}

.descript_block_text02 {
  width: 150px;
  height: 35px;
  line-height: 35px;
  text-align: left;
  padding-left: 10px;
  background: url(./assets/N_bd02.jpg) 0 100% no-repeat;
  font-size: 16px;
  color: #333;
  float: left;
}

.descript_block_text03 {
  width: 150px;
  height: 70px;
  line-height: 20px;
  color: #999;
  font-size: 12px;
  margin: 20px 0 0 45px;
  padding-left: 0;
}

.header {
  text-align: center;
  margin: 20px 0 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-line {
  width: 180px;
  height: 1px;
  background-color: #dcdcdc;
  margin: 0 10px;
  border: none;
}

.header h1 {
  color: #ff6a00;
  font-size: 22px;
  font-weight: 700;
  margin: 0;
}

/* 新增媒体查询，适配手机端 */
@media screen and (max-width: 800px) {
  .container {
    width: 80%;
    overflow-x: hidden; /* 禁止水平滚动 */
  }
  .footer_img1 {
    margin-top: 140px;
    height: 300px;
    width: 400px;
  }
  .img-responsive{
    width: 120%;
  }
  .header h1 {
    font-size: 14.5px; /* 手机端字体变小 */
  }
  .lab {
    width: 120px;
    font-size: 14px;
    font-weight: 500;
    margin-left: 20px;
  }
  .input-block {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    height: 65px;
    line-height: 32px;
  }
  .form-container {
    width: 90%;
    margin: 40px auto 0 70px;
  }
  .form-input {
    height: 32px;
    width: 200px;
    padding: 10px 10px;
  }
  .input-sub {
    width: 160px;
    height: 36px;
    line-height: 36px;
    background: #f60;
    float: left;
    border-radius: 30px;
    margin-left: 20px;
    margin-top: 80px;
  }
}
</style>
